var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "url(#paint0_linear_4478_4382)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4153 17.7773C11.7582 17.7773 12.85 16.7375 12.85 15.4585C12.85 14.1796 11.7582 13.1397 10.4153 13.1397C9.07236 13.1397 7.98054 14.1796 7.98054 15.4585C7.98054 16.7375 9.07236 17.7773 10.4153 17.7773ZM27.4583 17.7773C28.8012 17.7773 29.893 16.7375 29.893 15.4585C29.893 14.1796 28.8012 13.1397 27.4583 13.1397C26.1154 13.1397 25.0235 14.1796 25.0235 15.4585C25.0235 16.7375 26.1154 17.7773 27.4583 17.7773ZM28.6756 18.9367H26.2409C25.5714 18.9367 24.9665 19.1939 24.5252 19.6106C26.0583 20.4113 27.1463 21.8569 27.3822 23.5742H29.893C30.5663 23.5742 31.1103 23.0561 31.1103 22.4148V21.2554C31.1103 19.9765 30.0185 18.9367 28.6756 18.9367ZM18.9368 18.9367C21.2916 18.9367 23.1975 17.1215 23.1975 14.8788C23.1975 12.6361 21.2916 10.821 18.9368 10.821C16.5819 10.821 14.676 12.6361 14.676 14.8788C14.676 17.1215 16.5819 18.9367 18.9368 18.9367ZM21.8584 20.0961H21.5427C20.7514 20.4584 19.8726 20.6757 18.9368 20.6757C18.0009 20.6757 17.1259 20.4584 16.3309 20.0961H16.0151C13.5956 20.0961 11.6326 21.9656 11.6326 24.2699V25.3133C11.6326 26.2734 12.4505 27.0524 13.4586 27.0524H24.4149C25.423 27.0524 26.2409 26.2734 26.2409 25.3133V24.2699C26.2409 21.9656 24.2779 20.0961 21.8584 20.0961ZM13.3483 19.6106C12.907 19.1939 12.3022 18.9367 11.6326 18.9367H9.1979C7.855 18.9367 6.76318 19.9765 6.76318 21.2554V22.4148C6.76318 23.0561 7.30719 23.5742 7.98054 23.5742H10.4875C10.7272 21.8569 11.8152 20.4113 13.3483 19.6106Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4478_4382",
    x1: 19.5,
    y1: 0,
    x2: 19.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB2FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsersIcon);
export default __webpack_public_path__ + "static/media/totalUsersIcon.d96a4863f8c4cd6ee7a4a1e5d9e86474.svg";
export { ForwardRef as ReactComponent };